import React from "react"
import PropTypes from "prop-types"

import Fade from "react-reveal/Fade"

import "./TextBlock.scss"

// ACF returns the WYSIWYG value without wpautop applied, so paragraphs arrive
// as newline-separated text with no <p> tags. Wrap each block in a paragraph
// (single newlines become <br />). Skips the transform if the content already
// contains block-level HTML, so it stays correct if WP ever returns real markup.
const toParagraphs = (html) => {
  if (/<(p|br|ul|ol|h[1-6]|div|table|blockquote)\b/i.test(html)) return html

  return html
    .trim()
    .split(/\n\s*\n/)
    .map((block) => block.trim())
    .filter(Boolean)
    .map((block) => `<p>${block.replace(/\n/g, "<br />")}</p>`)
    .join("")
}

const TextBlock = ({ content }) => {
  if (!content) return null

  return (
    <Fade>
      <section className="textBlock">
        <div className="textBlock__container">
          <div
            className="textBlock__content"
            dangerouslySetInnerHTML={{ __html: toParagraphs(content) }}
          />
        </div>
      </section>
    </Fade>
  )
}

TextBlock.propTypes = {
  content: PropTypes.string,
}

export default TextBlock
